import React from "react";
import "./selectWithLabel.less";
import {
  Button,
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { DarkTooltip } from "../material-tooltip";
import { Close, InfoOutlined } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import sortBy from "lodash/sortBy";

export default function LabelWithSelect({
  optionsList = [],
  className = "selectContainer",
  labelHeading = "",
  selectedId = "",
  keyValue = "",
  isRequired = false,
  width = "100%",
  disabled = false,
  tooltipTitle = "",
  toolTip = "",
  id = "selectListLabel",
  onChange = () => {},
  openToolTipDialog = false,
  autofill= undefined
}) {
  const [openDialog, setOpenDialog] = React.useState(false);
  optionsList=sortBy(optionsList, x => ((x["ListOrderBy"] === undefined ||
      x["ListOrderBy"] === null) ? x.value : x["ListOrderBy"]));
  return (
    <>
    
      {openDialog && (
        <Dialog
          maxWidth={"md"}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby={"responsive-dialog-title"}
        >
          <div className={"header row"}>
            {" "}
            <div className={"col-xs-11"}> </div>
            <div className={"col-xs-1 center-xs"}>
              <Tooltip title={"Close"}>
                <IconButton
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  style={{ width: "fit-content" }}
                  aria-label={"close"}
                >
                  <Close fontSize={"small"} size={"small"} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <div>
            {toolTip && (
              <ul>
                {toolTip.split("~").map((text, index) => (
                  <>
                    <li key={index}>
                      <b>{text.split("–")[0]}{" - "}</b> {text.split("–")[1]}
                    </li>
                    <br />
                  </>
                ))}
              </ul>
            )}
            <Button
              autoFocus
              style={{ float: "right" }}
              onClick={() => setOpenDialog(false)}
              variant={"contained"}
            >
              {"Cancel\r"}
            </Button>
          </div>
        </Dialog>
      )}
      <DarkTooltip arrow title={tooltipTitle ? tooltipTitle : ""}>
       <> {autofill==undefined &&(
        <FormControl className={className} style={{ width: width }}>
          <InputLabel
            id={id + "selectLabel"}
            className={disabled ? "disabled-label" : ""}
          >
            <span>{labelHeading}</span>
            {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
            {toolTip && (
              <Tooltip
                title={
                  openToolTipDialog
                    ? "View " + labelHeading + " Description"
                    : toolTip
                }
              >
                <IconButton
                  style={{ pointerEvents: "auto" }}
                  size={"small"}
                  className={"tooltip-iconSize"}
                  onClick={() => openToolTipDialog && setOpenDialog(true)}
                >
                  <InfoOutlined fontSize={"inherit"} />
                </IconButton>
              </Tooltip>
            )}
          </InputLabel>
          <Select
            fullWidth
            required={!disabled}
            labelId={id + "selectLabel"}
            id={id}
            onChange={(event) => onChange(keyValue, event.target.value)}
            value={selectedId}
            placeholder={"Select User Group"}
            disabled={disabled}
          >
            {optionsList.map((x) => (
              <MenuItem key={"MenuUG" + x.id} size={"medium"} value={x.id}>
                {x.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>)}
       
        
        {autofill!==undefined && (
            <Autocomplete
            className={"search-box-wrapper"}
            size={"small"}
            underlineStyle={{ display: "none" }}
            onChange={(event,value) => onChange(keyValue, value)}
            labelId={id + "selectLabel"}
            id={id}
            //value={(optionsList||[]).find(x=>x.value===(selectedId || ""))}
           defaultValue={selectedId}
           value={selectedId}
            disabled={disabled}
            options={(optionsList || []).map((options)=>options.value)}
           // getOptionLabel={option => option.value}
            renderOption={option => (
              <Typography style={{ fontSize: "1rem" }}>
                {option}
              </Typography>
            )}
            renderInput={params => (
              <TextField
                {...params}
                autoComplete={"off"}
                inputProps={{ ...params.inputProps, style: { fontSize: "5rem" } }}
                InputLabelProps={{ style: { pointerEvents: "auto" } ,id:id + "selectLabel"}}
                id={id + "selectInputLabel"}
                className={disabled ? "disabled-label" : ""}
                label={<>
                  <span>{labelHeading}</span>
                  {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
                  {toolTip && (
                    <Tooltip
                      title={
                        openToolTipDialog
                          ? "View " + labelHeading + " Description"
                          : toolTip
                      }
                    >
                      <IconButton
                        style={{ pointerEvents: "auto" }}
                        size={"small"}
                        className={"tooltip-iconSize"}
                        onClick={() => openToolTipDialog && setOpenDialog(true)}
                      >
                        <InfoOutlined fontSize={"inherit"} />
                      </IconButton>
                    </Tooltip>
                  )}
                       </>}
                disabled={disabled}
              />
        )} 
            />)}
       </>
      </DarkTooltip>
    </>
  );
}
